'use strict';

var index = require('../../index-c6190cd6.js');
var theme_components_IconWrapper = require('./IconWrapper.js');

var IndeterminateCheckboxIcon = (props = {}) => (index.React.createElement(theme_components_IconWrapper, { ...props },
    index.React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
        index.React.createElement("g", { id: "Misc-/Checkbox-Atom-/Indeterminate", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            index.React.createElement("rect", { id: "CheckboxIndeterminate", fill: "currentColor", x: "0", y: "0", width: "16", height: "16", rx: "3" }),
            index.React.createElement("rect", { id: "CheckboxIndeterminate-Part", fill: "#FFFFFF", x: "4", y: "7", width: "8", height: "2", rx: "1" })))));

module.exports = IndeterminateCheckboxIcon;
